<div class="content-box content-text">
    <div class="container">
        <div class="col-md-12">
            <div class="banner-superior">
                <mat-select class="select-form language" placeholder="Idioma">
                    <mat-option value="1">Floor</mat-option>
                    <mat-option value="2">Español</mat-option>
                    <mat-option value="3">Inglés</mat-option>
                </mat-select>
                <button (click)="openModalPreviousEditions()" class="button-secondary previous editions">
                    <mat-icon aria-hidden="false" aria-label="visibility">visibility</mat-icon>Ediciones anteriores
                </button>
                <p class="page-title"><strong>Transcripción</strong> - 22/15/2021</p>
            </div>

            <div class="text-container">
                <div class="col-md-12">
                    <h2 mat-dialog-title class="principal-title">Transcripción Reunión 1</h2>
                    <p><strong class="subtitles">Orador: Juan Peréz / 12:33:22</strong></p>
                    <p><strong class="subtitles">Edición: Juana Gonzalez / 15-02-2021. 18:30:55</strong></p>
                    <p>Est ei erat mucius quaeque. Ei his quas phaedrum, efficiantur mediocritatem ne sed, hinc
                        oratio
                        blandit ei sed. Blandit gloriatur eam et. Brute noluisse per et, verear disputando
                        neglegentur at
                        quo. Sea quem legere ei, unum soluta ne duo. Ludus complectitur quo te, ut vide autem
                        homero pro.</p>
                </div>
                <div class="col-md-12">
                    <p><strong class="subtitles">Orador: Juan Peréz / 12:33:22</strong></p>
                    <p><strong class="subtitles">Edición: Juana Gonzalez / 15-02-2021. 18:30:55</strong></p>
                    <p>Est ei erat mucius quaeque. Ei his quas phaedrum, efficiantur mediocritatem ne sed, hinc
                        oratio
                        blandit ei sed. Blandit gloriatur eam et. Brute noluisse per et, verear disputando
                        neglegentur at
                        quo. Sea quem legere ei, unum soluta ne duo. Ludus complectitur quo te, ut vide autem
                        homero pro.</p><br>
                </div>
                <div class="col-md-12">
                    <p><strong class="subtitles">Orador: Juan Peréz / 12:33:22</strong></p>
                    <p><strong class="subtitles">Edición: Juana Gonzalez / 15-02-2021. 18:30:55</strong></p>
                    <p>Est ei erat mucius quaeque. Ei his quas phaedrum, efficiantur mediocritatem ne sed, hinc
                        oratio
                        blandit ei sed. Blandit gloriatur eam et. Brute noluisse per et, verear disputando
                        neglegentur at
                        quo. Sea quem legere ei, unum soluta ne duo. Ludus complectitur quo te, ut vide autem
                        homero pro.</p><br>
                </div>
                <div class="col-md-12">
                    <p><strong class="subtitles">Orador: Juan Peréz / 12:33:22</strong></p>
                    <p><strong class="subtitles">Edición: Juana Gonzalez / 15-02-2021. 18:30:55</strong></p>
                    <p>Est ei erat mucius quaeque. Ei his quas phaedrum, efficiantur mediocritatem ne sed, hinc
                        oratio
                        blandit ei sed. Blandit gloriatur eam et. Brute noluisse per et, verear disputando
                        neglegentur at
                        quo. Sea quem legere ei, unum soluta ne duo. Ludus complectitur quo te, ut vide autem
                        homero pro.</p><br>
                </div>
                <div class="col-md-12">
                    <p><strong class="subtitles">Orador: Juan Peréz / 12:33:22</strong></p>
                    <p><strong class="subtitles">Edición: Juana Gonzalez / 15-02-2021. 18:30:55</strong></p>
                    <p>Est ei erat mucius quaeque. Ei his quas phaedrum, efficiantur mediocritatem ne sed, hinc
                        oratio
                        blandit ei sed. Blandit gloriatur eam et. Brute noluisse per et, verear disputando
                        neglegentur at
                        quo. Sea quem legere ei, unum soluta ne duo. Ludus complectitur quo te, ut vide autem
                        homero pro.</p><br>
                </div>
                <div class="col-md-12">
                    <p><strong class="subtitles">Orador: Juan Peréz / 12:33:22</strong></p>
                    <p><strong class="subtitles">Edición: Juana Gonzalez / 15-02-2021. 18:30:55</strong></p>
                    <p>Est ei erat mucius quaeque. Ei his quas phaedrum, efficiantur mediocritatem ne sed, hinc
                        oratio
                        blandit ei sed. Blandit gloriatur eam et. Brute noluisse per et, verear disputando
                        neglegentur at
                        quo. Sea quem legere ei, unum soluta ne duo. Ludus complectitur quo te, ut vide autem
                        homero pro.</p><br>
                </div>
                <div class="col-md-12">
                    <p><strong class="subtitles">Orador: Juan Peréz / 12:33:22</strong></p>
                    <p><strong class="subtitles">Edición: Juana Gonzalez / 15-02-2021. 18:30:55</strong></p>
                    <p>Est ei erat mucius quaeque. Ei his quas phaedrum, efficiantur mediocritatem ne sed, hinc
                        oratio
                        blandit ei sed. Blandit gloriatur eam et. Brute noluisse per et, verear disputando
                        neglegentur at
                        quo. Sea quem legere ei, unum soluta ne duo. Ludus complectitur quo te, ut vide autem
                        homero pro.</p><br>
                </div>
                <div class="col-md-12">
                    <p><strong class="subtitles">Orador: Juan Peréz / 12:33:22</strong></p>
                    <p><strong class="subtitles">Edición: Juana Gonzalez / 15-02-2021. 18:30:55</strong></p>
                    <p>Est ei erat mucius quaeque. Ei his quas phaedrum, efficiantur mediocritatem ne sed, hinc
                        oratio
                        blandit ei sed. Blandit gloriatur eam et. Brute noluisse per et, verear disputando
                        neglegentur at
                        quo. Sea quem legere ei, unum soluta ne duo. Ludus complectitur quo te, ut vide autem
                        homero pro.</p>
                </div>
            </div>
            <div mat-dialog-actions>
                <button class="button-close" mat-button (click)="closeModal()">
                    <mat-icon aria-hidden="false" aria-label="close">close</mat-icon>Cancelar
                </button>
            </div>
        </div>
    </div>
</div>
